module.exports = __webpack_public_path__ + "img/MEDIA039.8de7bd6d.jpg";